import { render, staticRenderFns } from "./sysDictionaryAdd.vue?vue&type=template&id=05177df4&scoped=true&"
import script from "./sysDictionaryAdd.vue?vue&type=script&lang=js&"
export * from "./sysDictionaryAdd.vue?vue&type=script&lang=js&"
import style0 from "./sysDictionaryAdd.vue?vue&type=style&index=0&id=05177df4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05177df4",
  null
  
)

component.options.__file = "sysDictionaryAdd.vue"
export default component.exports